import { c as _c } from "react/compiler-runtime";
import { Alert } from "@website/ui/alert";
import { useSnackbarItem } from "@website/ui/snackbar/components/snackbar-item/snackbar-item.hook";
import styles from "@website/ui/snackbar/components/snackbar-item/snackbar-item.module.scss";
import { SnackbarItemPropertiesType } from "@website/ui/snackbar/components/snackbar-item/snackbar-item.types";
import { FC } from "react";
export const SnackbarItem: FC<SnackbarItemPropertiesType> = properties => {
  const $ = _c(3);
  const {
    index
  } = properties;
  const {
    alertProps,
    show
  } = useSnackbarItem(properties);
  const t0 = `${styles.container} ${show ? "" : styles.hide} ${index === 0 && styles.first} ${index === 1 && styles.second} ${index === 2 && styles.third}`;
  let t1;
  if ($[0] !== alertProps || $[1] !== t0) {
    t1 = <Alert {...alertProps} className={t0} />;
    $[0] = alertProps;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};